import axios from 'axios';
import config from '../config';
import localStorage from 'store';
import toast from '../utils/toast';
import i18next from 'i18next';

const instance = axios.create({
  baseURL: config.API_URL,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  validateStatus: status => status >= 200 && status < 300,
});

instance.interceptors.request.use(
  function (config) {
    const token = localStorage.get('token');
    config.headers.lang = localStorage.get('lang');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    let insuranceItem = localStorage.get('insurance_item');

    if (insuranceItem?.value) {
      config.headers['insurance-code'] = insuranceItem.value;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    let response = error.response;

    if (response) {
      let code = response.status;
      let message = response.data.message;

      switch (code) {
        case 400:
          toast.error({
            message: message,
            placement: 'bottomRight',
          });
          break;
        case 403:
          toast.error({
            message: message,
            placement: 'bottomRight',
          });
          break;
        case 401:
          toast.error({
            message: i18next.t('messages.errors.401'),
            placement: 'bottomRight',
          });
          break;
        case 422:
          toast.error({
            message: i18next.t('messages.errors.422'),
            placement: 'bottomRight',
          });
          break;
        default:
          toast.error({
            message: i18next.t('messages.errors.500'),
            placement: 'bottomRight',
          });
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
